import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	username?: string;
};

const PopsizeSpinningLoaderLargeStandard: FC<Props> = ({ username }) => {
	const [dotCount, setDotCount] = useState(3);
	const [rotationDuration, setRotationDuration] = useState('1.5s');
    const { t } = useTranslation();

	useEffect(() => {
		// Randomize rotation duration between 1 and 2 seconds
		const random = (Math.random() * (2 - 1) + 1).toFixed(2);
		setRotationDuration(`${random}s`);

		// Animate dots
		const interval = setInterval(() => {
			setDotCount((prev) => (prev + 1) % 4); // cycle through 0–3 dots
		}, 500);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className="pop-flex pop-flex-col pop-items-center pop-justify-center pop-h-screen pop-w-full pop-px-4 pop-text-center pop-box-border">

			<div className="pop-mb-6">
				<div
					style={{
						animation: `spinClockwise ${rotationDuration} linear infinite`,
						display: 'inline-block',
					}}
				>
					{/* SVG Logo */}
					<svg
						width="auto"
						height="100"
						viewBox="0 0 50 50"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<mask
							id="mask0_4_395"
							style={{ maskType: 'luminance' }}
							maskUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="50"
							height="50"
						>
							<path d="M50 0H0V50H50V0Z" fill="white" />
						</mask>
						<g mask="url(#mask0_4_395)">
							<path
								d="M24.7871 19.0716C26.0024 15.828 27.2272 13.2566 28.4618 11.3475C29.6968 9.43837 31.0384 8.0747 32.4964 7.24677C33.9548 6.41884 35.656 6 37.6007 6C38.5046 6 39.2533 6.0974 39.8367 6.28247V11.9416C39.7005 11.9027 39.5158 11.8734 39.2924 11.854C39.0686 11.8345 38.8353 11.8247 38.5922 11.8247C36.8519 11.8247 35.384 12.4871 34.1688 13.802C32.9535 15.1267 31.7382 17.367 30.5229 20.5326L26.0411 32.4744C24.8258 35.7179 23.5912 38.2991 22.3467 40.2278C21.0927 42.1562 19.712 43.5297 18.2054 44.3575C16.6985 45.1857 14.8998 45.6044 12.8095 45.6044C12.2845 45.6044 11.7888 45.5653 11.3025 45.4876C10.8166 45.4095 10.3793 45.3219 10 45.2051V39.546C10.4859 39.7018 11.0791 39.7697 11.7694 39.7697C13.7138 39.7697 15.3277 39.1076 16.6109 37.7926C17.8941 36.4679 19.129 34.2081 20.3053 31.0036L24.7871 19.0716Z"
								fill="#FFAA00"
							/>
						</g>
					</svg>
				</div>
			</div>

			<style>
				{`
					@keyframes spinClockwise {
						from { transform: rotate(0deg); }
						to { transform: rotate(360deg); }
					}
				`}
			</style>
		</div>
	);
};

export default PopsizeSpinningLoaderLargeStandard;
